import React from 'react';
import styled from 'styled-components';
import { FlexCenter } from '@ubeya/shared-web/components';
import { ReactComponent as BaseArchiveIcon } from '@ubeya/shared-web/assets/archive.svg';

const Badge = styled(FlexCenter)`
  width: 28px;
  height: 28px;
  background: ${({ theme }) => theme.colors.disabled};
  border-radius: 100%;
  flex-shrink: 0;
`;

const ArchiveIcon = styled(BaseArchiveIcon)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;

  path {
    fill: ${({ theme }) => theme.colors.grey4};
  }
`;

const ClosedBadge = () => (
  <Badge>
    <ArchiveIcon />
  </Badge>
);

export default ClosedBadge;
